import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import AurLoadingIndicator from '../components/common/aur-loading-indicator/AurLoadingIndictor';
import useAuthorizationContext from '../hooks/authorizationContext/useAuthorizationContext';
import { selectUserAuthzLoadedAt } from '../redux/slices/userSlice';
import { Permissions, Resources } from '../utils/authorization';

interface AuthorizedRouteProps {
  permission: Permissions;
  resource: Resources;
  userKind: number;
}

const AuthorizedRoute: React.FC<AuthorizedRouteProps> = ({
  permission,
  resource,
  userKind
}) => {
  const authLoadedAt = useSelector(selectUserAuthzLoadedAt);
  const i = useAuthorizationContext();

  if (!authLoadedAt) {
    return <div className='centered-container'><AurLoadingIndicator show={true} /></div>
  } else {
    if (i.can(permission, resource)) {
      return <Outlet />;
    }
    if (userKind === 1)
      return <Navigate to="*" />;
    else
      return <Navigate to="/unauthorized" />;
  }
};
export default AuthorizedRoute;
